module.exports = require('./dist/Sticky');



//////////////////
// WEBPACK FOOTER
// ./~/react-stickynode/index.js
// module id = 2313
// module chunks = 0